import * as z from "zod/v4";

const SlackUserSchema_ = z.object({
  id: z.string(),
  name: z.string(),
  displayName: z.string(),
  email: z.string().optional(),
  avatarUrl: z.string().optional(),
});

export const SlackUserSchema: z.ZodType<SlackUser> = SlackUserSchema_;
export interface SlackUser extends z.infer<typeof SlackUserSchema_> {}

export const searchSlackUsers = {
  name: "searchSlackUsers" as const,
  input: z.object({ query: z.string() }),
  output: z.object({ users: z.array(SlackUserSchema) }),
};
